interface FieldChange {
  field: string
  label: string
  old: string
  new: string
}

export function FieldUpdateDiff({ notes }: { notes: string }) {
  let changes: FieldChange[] = []
  try {
    const parsed = JSON.parse(notes) as { changes?: FieldChange[] }
    changes = parsed.changes ?? []
  } catch {
    return <p className="text-muted-foreground mt-2 text-sm">{notes}</p>
  }
  if (changes.length === 0) return null
  return (
    <ul className="mt-2 space-y-1 text-sm">
      {changes.map((change) => (
        <li key={change.field} className="flex flex-wrap items-center gap-1">
          <span className="text-muted-foreground">{change.label}:</span>
          <span className="rounded bg-red-50 px-1.5 py-0.5 text-xs text-red-700 line-through">
            {change.old || '—'}
          </span>
          →
          <span className="rounded bg-green-50 px-1.5 py-0.5 text-xs text-green-700">
            {change.new || '—'}
          </span>
        </li>
      ))}
    </ul>
  )
}
